import {BaseService} from "./base.service";

class AgentsService extends BaseService {

    constructor() {
        super('api/agents')
    }

    getAgentByPromoterId(promoterId) {
        return this.http.get(`api/get-agent-by-promoter-id/${promoterId}`).then(response => response.data).catch(err => err.message);
    }

}

export const agentsService = new AgentsService();
